import React from "react";
import CellInput from "../../global/CellInput";
import { translateLabel } from "../../../services/functions";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
} from "@fortawesome/free-solid-svg-icons";


const moment = require("moment");
const generatePaymentOrderColumns = (
    {
        t,
        i18n,
    }
        = {}) => {
    // let columns = queueColumns != null ? queueColumns.split(",") : null;


    const profileIdOptions = profileIdOptions?.map((profId) => ({ ...profId, label: t([profId.label]) }))


    const currencyOptions = [
        { value: "ALL", label: "Lek" },
        { value: "EUR", label: "Euro" },
        { value: "USD", label: "USD" },
    ];

    const statusOptions = [

        {
            label: "Created",
            value: "CREATED"
        },
        {
            label: "Proccessed",
            value: "Proccessed"
        },
        {
            label: "Failed",
            value: "Failed"
        },
    ]

    return [
        {
            header: t(["home.actions"]),
            style:{minWidth: "120px",maxWidth:"120px"},
            field: "actions",
            body: (invoice) => (
                <Link
                  to={"/edit-payment-order/" + invoice.id}
                  className={"nav-link p-0 d-flex align-items-center mr-3"}
                >
                  <FontAwesomeIcon icon={faEye} className="mx-1" />
                  {t("invoice.view")}
                </Link>

            ),
            persisted: true    
          },

        {
            header: t(["home.status"]),
            field: "status",
            style: { minWidth: "180px", maxWidth: "180px" },
            filter: true,
            persisted: true,
            body:(order)=>order?.status?.name,
            filterType: "DROPDOWN",
            filterConfig: {
                options: statusOptions,
                optionValue: "value",
                optionLabel: "label",
            },
        },
        {
            field: "recordDate",
            header: t(["table.recordDate"]),
            body: (order) => order?.recordDate ? moment(order?.recordDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: 180, maxWidth: 180 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,

            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,

        },
        {
            header: "Requested Execution Date",
            field: "requestedExecutionDate",
            body: (order) => order?.requestedExecutionDate ? moment(order?.requestedExecutionDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: 230, maxWidth: 230 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,
        },
        {
            header: t(["invoice.currency"]),
            field: "currency",
            default: true,
            persisted: true,
            sortable: true,
            style: { minWidth: "150px", maxWidth: "300px" },
            body: (order) => order.currency,
            filter: true,
            filterType: "MULTISELECT",
            filterConfig: {
                options: currencyOptions
            }
        },
        {
            header: t(["table.recordUser"]),
            field: "recordUser",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            persisted: true,
            default: true,
        },
        {
            header: t("paymentOrder.accountRef"),
            field: "creditorAccountReference",
            style: { minWidth: "180px"},
            filter: true,
            body: (order) => <CellInput value={order?.creditorAccountReference ?? ""} width={220} />,
            default: true,
        },
        {
            header: t("paymentOrder.refType"),
            field: "creditorAccountReferenceType",
            style: { minWidth: "220px", maxWidth: "220px" },
            filter: true,
            default: true,
        },
        {
            header: t(["paymentOrder.creditorName"]),
            field: "creditorName",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            default: true,
        },
        {
            header: t(["paymentOrder.creditorAgent"]),
            field: "creditorAgent",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            default: true,
        },
        {
            header: "Agent Type",
            field: "creditorAgentType",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            default: true,
        },
        {
            header: "Identifier",
            field: "endToEndId",
            style: { minWidth: "220px", maxWidth: "240px" },
            filter: true,
            body: (order) => <CellInput value={order?.endToEndId ?? ""} width={220} onFocus={(event) => event.target.select()} />,
            default: true,
        },
        {
            header: "Purchase Invoice Id",
            field: "purchaseInvoiceId",
            style: { minWidth: "170px", maxWidth: "180px" },
            filter: true,
            default: true,
        },
        {
            header: t(["item.notes"]),
            field: "remittanceInformation",
            style: { minWidth: "170px", maxWidth: "170px" },
            default: true,
        },
        {
            header: "Information Type",
            field: "remittanceInformationType",
            style: { minWidth: "150px", maxWidth: "150px" },
            default: true,
        },
        {
            header: t(['stat.total']),
            field: "amount",
            style: { minWidth: "180px", maxWidth: "200px" },
            sortable: true,
            persisted: true,
            default: true,
            sortable: true,
        },

    ];
};

export default generatePaymentOrderColumns;
